import request, { DefaultResponseData } from '@utils/request';

export interface RefreshTokenResp {
  name?: string;
  nick_name?: string;

  userid: string;
  wemeet_sign?: string;
  user_type?: number;

  avatar?: string;
  avatar_type?: string;
  avatar_token?: string;

  app_id: string;
  user_district?: any;
}

export interface SendSmsReq {
  business_id: string;
  phone: string;
  area: string;
  /** @description 防水墙返回的串 */
  rand_string?: string;
  /** @description 防水墙返回的串 */
  ticket?: string;
}
/**
 * @description 获取用户信息
 * @param params
 * @returns
 */
export async function getRefreshToken(params: any): Promise<DefaultResponseData<RefreshTokenResp>> {
  return await request({
    url: '/v2/account/login/refresh-token',
    data: params,
    type: 'POST',
  });
}

/**
 * @description 获取账号列表
 */
export async function fetchAccounts(): Promise<DefaultResponseData<{ is_can_change_account: boolean }>> {
  return await request({
    url: 'v2/account/profile/change-account',
    data: {},
    type: 'GET',
  });
}

/**
 * @description 退出登录
 */
export async function logout(): Promise<DefaultResponseData<any>> {
  return await request({
    url: 'v2/account/logout',
    data: {},
    type: 'GET',
  });
}

/**
 * @description 发送手机验证码
 */
export async function sendSmsCode(params: SendSmsReq): Promise<DefaultResponseData<any>> {
  return await request({
    // url: 'v2/common/msg/send-phone-code',
    // 需要替换成以下的新接口 https://tapd.woa.com/tapd_fe/20375092/story/detail/1020375092127247571
    url: 'v2/login-logic/msg/safe-send-phone-verify-code',
    data: params,
    type: 'POST',
  });
}

/**
 * @description 校验手机号是否正确
 */

export async function checkMobile(
  params: Pick<SendSmsReq, 'area' | 'business_id' | 'phone'> & { code: string },
): Promise<DefaultResponseData<any>> {
  return await request({
    url: 'v2/common/msg/check-phone-code',
    data: params,
    type: 'POST',
  });
}

export interface CheckLawFulReq {
  lawful_type: 'guest_join';
  auth_code?: string;
  device_id: string;
  meeting_code: string;
}
/**
 * @description 是否合规
 */
export async function checkLawFul(params: CheckLawFulReq): Promise<DefaultResponseData<any>> {
  return await request({
    url: 'v2/lawful/process/check-service-agreement-approve',
    data: params,
    type: 'POST',
  });
}
